import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceTemplateInvocation  {
    _originalTypeClassName = "zERP.BO.InvoiceTemplateInvocation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceTemplateInvocation.translate = translateService;
}
this.Lines = [];
this.TemplateId = null;
this.ContextId = null;
this.ContextType = null;
this.EntityId = null;
this.ExistingInvoiceId = null;
this.ExpenseSeries = null;
this.ExpenseAA = null;
this.BankAccountId = null;
this.CashAccountId = null;
this.InvoiceTemplateInvocationKey = null;
this._key = this.InvoiceTemplateInvocationKey = 0; 
}

static translate: TranslateService;
_key: any;
TemplateId:any;
ContextId:any;
ContextType:any;
EntityId:any;
ExistingInvoiceId:any;
ExpenseSeries:any;
ExpenseAA:any;
BankAccountId:any;
CashAccountId:any;
Lines:any;
InvoiceTemplate:any;
private _InvoiceTemplateInvocationKey:any;
get InvoiceTemplateInvocationKey(): any {
    return this._InvoiceTemplateInvocationKey;
  }
set InvoiceTemplateInvocationKey(value: any) {
    this._InvoiceTemplateInvocationKey = value;
    this._key = value;
  }
static setLines = ($this, items) => {
                if (items == null) items = [];
                if ($this.Lines == null) $this.Lines = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Lines.length > 0) {
                    Domain.InvoiceTemplateInvocation.removeLines($this, $this.Lines[0]);
                }

                Domain.InvoiceTemplateInvocation.addManyLines($this, copyItems);
            }
static addManyLines = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceTemplateInvocation.addLines($this, items[i]);
                }
            }
static addLines = ($this, item) => {
                if ($this.Lines == null) $this.Lines = [];
                if (item == null || $this.Lines.indexOf(item) > -1) return;
                $this.Lines.push(item);
}
static addRangeLines = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceTemplateInvocation.addLines($this, item));
            }
static removeLines = ($this, item) => {
                if ($this == null || $this.Lines == null || $this.Lines.indexOf(item) === -1) return;
                var _index = $this.Lines.indexOf(item);
                $this.Lines.splice(_index, 1);
}
static clearLines = ($this) => { $this.Lines = null; }
static setInvoiceTemplate = ($this, value) => {
var oldValue = $this.InvoiceTemplate;
$this.InvoiceTemplate = value;
if (value != null) {
}
}

static HandleDecimal($this: any, initial: any,decimals: any): any{let updated = Joove.Common.mathRound(initial, decimals);
return updated;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InvoiceTemplateInvocationKey == null || $this.InvoiceTemplateInvocationKey == 0;
            }


}